const REQUEST_WALLBOARD_STATS = "REQUEST_WALLBOARD_STATS";
const RECEIVE_WALLBOARD_STATS = "RECEIVE_WALLBOARD_STATS";

export default {
    REQUEST_WALLBOARD_STATS, 
    RECEIVE_WALLBOARD_STATS, 
}